import { Component, Input, OnInit, Output,EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumbModel } from '../../models/campaign-3-breadcrumb.model';

@Component({
  selector: 'app-campaign-3-breadcrumb',
  templateUrl: './campaign-3-breadcrumb.component.html',
  styleUrls: ['./campaign-3-breadcrumb.component.css']
})
export class Campaign3BreadcrumbComponent implements OnInit {
  
  @Input() arrayBreadcrumbs: Array<BreadCrumbModel> = [];
  @Input() campaignTypeName: string = "";
  @Input() campaignTypeDescription: string = "";
  @Output() onClickBreadcrumb: EventEmitter<BreadCrumbModel> = new EventEmitter<BreadCrumbModel>();

 //Nuovi campi per generalizzazione
  @Input() homeLink= "";

  constructor() { }

  ngOnInit() {

  }
  onClickHome(){

  }
  onClick(breadbrumb: BreadCrumbModel){
    this.onClickBreadcrumb.emit(breadbrumb);
  }
  

}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component.ts